export const FLUID_COLUMN = 'minmax(0, 1fr)'
